<template>
  <el-dialog
      :close-on-click-modal="false"
      :title="Cari?Cari.Unvan+' Hareket':'Hareket İşle'"
      :visible.sync="Durum"
      :before-close="Kapat"
      :v-loading="lo"
      width="40%">
    <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
             ref="Form">
      <el-row :gutter="24">
        <el-col :span="16" v-if="!Cari">
          <el-form-item label="Cari" prop="Cari_id">
            <el-select v-model="Form.Cari_id" filterable placeholder="Cari Seçiniz">
              <el-option
                  v-for="item in Cariler"
                  :key="item.id"
                  :label="item.Unvan"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Vade Tarihi" prop="vTarih">
            <el-date-picker
                autocomplete="off"
                v-model="Form.vTarih"
                type="date"
                format="dd.MM.yyyy">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="Cari?8:12">
          <el-form-item label="Tutar" prop="Tutar">
            <el-input type="text" v-model="Form.Tutar" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="Cari?8:12">
          <el-form-item label="Hizmet" prop="Hizmet_id">
            <el-select v-model="Form.Hizmet_id" @change="HizmetSecim" filterable placeholder="Hizmet Seçiniz">
              <el-option
                  v-for="item in Hizmetler"
                  :key="item.id"
                  :label="item.Adi"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="UrunListe">
          <table class="table table-bordered table-sm mb-3">
            <thead>
            <tr>
              <th colspan="3" class="bg-gray">Stok Kartı</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td width="20">
                <small class="d-block">Adet</small>
                <el-input type="text" size="mini" @change="UrunHesapla" v-model="Form.uAdet"
                          autocomplete="off"></el-input>
              </td>
              <td width="20" class="text-right">
                <small class="d-block">Alış Fiyatı</small>
                {{ Urun.Alis }}
              </td>
              <td width="20" class="text-right">
                <small class="d-block">Satış Fiyatı</small>
                {{ Urun.Satis }}
              </td>
            </tr>
            </tbody>
          </table>
        </el-col>
        <el-col :span="24">
          <el-form-item label="Açıklama" prop="Aciklama">
            <el-input type="textarea" v-model="Form.Aciklama" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="text-center">
          <el-switch
              v-model="Form.Tur"
              @change="UrunHesapla"
              active-text="Satış Fişi"
              inactive-text="Alış Fişi">
          </el-switch>
        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="!lo" size="small" type="danger" @click="Kapat">İptal</el-button>
      <el-button size="small" type="primary" :loading="lo" @click="Gonder">Kaydet</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['Cari', 'Durum'],
  data() {
    return {
      ModalBaslik: '',
      lo: false,
      Urun: null,
      UrunListe: false,
      Form: {
        Hizmet_id: null,
        Tur: true,
        Tutar: '',
        Aciklama: '',
        vTarih: '',
        Cari_id: null,
        uAdet: 0,
      },
      Cariler: null,
      Hizmetler: null,
      FormHata: {
        Cari_id: [{required: true, message: "Cari Seçiniz", trigger: 'blur'}],
        Hizmet_id: [{required: true, message: "Hizmet Seçiniz", trigger: 'blur'}],
        Tutar: [{required: true, message: "Tutar Giriniz", trigger: 'blur'}],
        Aciklama: [{required: true, message: "Açıklama Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {
    UrunHesapla() {
      if (this.UrunListe) {
        this.Form.Tutar = (this.Form.Tur ? this.Urun.Satis : this.Urun.Alis) * this.Form.uAdet;
        this.$notify.info({
          title: "Tutar Güncellendi",
          customClass: 'info'
        });
      }
    },
    HizmetSecim() {
      this.Urun = this.Hizmetler.filter(c => c.id === this.Form.Hizmet_id)[0];
      if (!this.Urun.Urun) {
        this.Form.uAdet = 0
        this.UrunListe = false
      } else {
        this.UrunListe = true
      }
    },
    Kapat() {
      this.$emit('Durum')
    },
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          this.$store.dispatch("Post", {...this.Form, path: 'hareket'})
              .then(response => {
                if (response.Durum == "OK") {
                  this.$emit('Durum')
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass: 'success'
                  });
                  this.lo = false
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass: 'error'
                  });
                  this.lo = false
                }
              })
        }
      })

    }
  },
  created() {
    if (this.Cari) this.Form.Cari_id = this.Cari.id
    this.$store.dispatch("Get", {path: 'cari/'})
        .then(response => {
          this.Cariler = response.Liste
        })
    this.$store.dispatch("Get", {path: 'hizmet/'})
        .then(response => {
          this.Hizmetler = response.Liste
        })
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Muhasebe/Comp/HareketIsle.vue